export { default } from './Label';
export { getLabelStyles } from './Label.styles';
